import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { isSimpleClick } from '@ember/-internals/views';
import PS from 'mewe/utils/pubsub';

export default class MwFollowedPageItem extends Component {
  @service router;

  @action
  openLink(e) {
    if (!isSimpleClick(e)) return;
    e.preventDefault();
    window.scrollTo(0, 0);
    PS.Pub('sidebar.action.mobile');
    this.args.closeSearch?.(); // if component is used in page search results
    this.router.transitionTo(`${this.args.item.linkToRoute}.feed`, this.args.item.linkToId);
  }
}
